module.exports = {
  API_URL: 'https://api-dev.konekto.ba/api',
  ENV: 'development',
  DEBUG: true,
}
